import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.75 3a.75.75 0 0 0-1.5 0v18a.75.75 0 0 0 1.5 0v-4.293a.8.8 0 0 0 .25.043h2a.75.75 0 0 0 .75-.75V7A.75.75 0 0 0 7 6.25H5a.8.8 0 0 0-.25.043zM19.25 3a.75.75 0 0 1 1.5 0v18a.75.75 0 0 1-1.5 0v-4.293a.8.8 0 0 1-.25.043h-2a.75.75 0 0 1-.75-.75V7a.75.75 0 0 1 .75-.75h2q.133 0 .25.043z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }